import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface KotState {
  loading: boolean;
  configs: any[];
  count: number;
  saveLoading: boolean;
  saveMessage: string;
  deleteLoading: boolean;
  deleteMessage: string;
  error: string;
}

const initialState: KotState = {
  loading: false,
  configs: [],
  count: 0,
  saveLoading: false,
  saveMessage: "",
  deleteLoading: false,
  deleteMessage: "",
  error: "",
};

const kotSlice = createSlice({
  name: "kot",
  initialState,
  reducers: {
    // Fetch list
    getKotConfigs: (state, _action: PayloadAction<any>) => {
      state.loading = true;
      state.error = "";
    },
    getKotConfigsSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.configs = action.payload?.data || action.payload?.configs || [];
      state.count = action.payload?.count || 0;
    },
    getKotConfigsFail: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Save (add or update)
    saveKotConfig: (state, _action: PayloadAction<any>) => {
      state.saveLoading = true;
      state.saveMessage = "";
    },
    saveKotConfigSuccess: (state, action: PayloadAction<string>) => {
      state.saveLoading = false;
      state.saveMessage = action.payload;
    },
    saveKotConfigFail: (state, action: PayloadAction<string>) => {
      state.saveLoading = false;
      state.error = action.payload;
    },

    // Delete
    deleteKotConfig: (state, _action: PayloadAction<string>) => {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteKotConfigSuccess: (state, action: PayloadAction<string>) => {
      state.deleteLoading = false;
      state.deleteMessage = action.payload;
    },
    deleteKotConfigFail: (state, action: PayloadAction<string>) => {
      state.deleteLoading = false;
      state.error = action.payload;
    },

    clearKotData: (state) => {
      state.saveMessage = "";
      state.deleteMessage = "";
      state.error = "";
    },
  },
});

export const kotActions = kotSlice.actions;

// Selectors
export const selectKotLoading    = (state: any) => state.kot?.loading;
export const selectKotConfigs    = (state: any) => state.kot?.configs || [];
export const selectKotCount      = (state: any) => state.kot?.count || 0;
export const selectKotSaveLoading  = (state: any) => state.kot?.saveLoading;
export const selectKotSaveMessage  = (state: any) => state.kot?.saveMessage;
export const selectKotDeleteLoading = (state: any) => state.kot?.deleteLoading;
export const selectKotDeleteMessage = (state: any) => state.kot?.deleteMessage;

export default kotSlice.reducer;
